import { effect, inject, Injectable, untracked } from '@angular/core';

import { agentAccount, customerAccount, userAccount } from '@features/auth/store/auth.signals';

import { CHATBOT_CONTEXT_IDS } from '../constants/chatbot-contexts';
import { ChatbotContextService } from './chatbot-context';

@Injectable({
    providedIn: 'root',
})
export class ChatbotAccountContextService {
    private readonly contextService = inject(ChatbotContextService);

    initialize(): void {
        effect(() => {
            const user = userAccount();
            const agent = agentAccount();
            const customer = customerAccount();

            untracked(() => {
                if (!user) {
                    this.contextService.remove(CHATBOT_CONTEXT_IDS.USER_INFO);

                    return;
                }

                const accountType = agent ? 'Agent' : customer ? 'Customer' : 'User';
                const details: string[] = [
                    `Name: ${user.fullName}`,
                    `Role: ${accountType}`,
                    `Company: ${user.companyName}`
                ];

                if (agent) {
                    details.push(`Office: ${agent.officeName}`);
                    details.push(`Agent Number: ${agent.agentNumber}`);
                }

                const message = details.join(', ');

                this.contextService.set(
                    CHATBOT_CONTEXT_IDS.USER_INFO,
                    'User Account',
                    message
                );
            });
        });
    }
}
